import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { TcpEchoRequest, TcpEchoResultDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/tcp/echo — TCP echo 왕복 (INTEGRATION_INVOKE)
 * 성공 시 call-logs 캐시 무효화 (§Δ.1 append-only 재사용)
 */
export function useTcpEcho() {
  const queryClient = useQueryClient();
  return useMutation<TcpEchoResultDto, { code: string; message: string }, TcpEchoRequest>({
    mutationFn: (req) => integrationHubApi.tcpEcho(req),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'call-logs'] });
    },
  });
}
